export enum EntityStoreStorageType {

    Local = 0,
    Remote = 1

}

export class EntityStoreConfig {

    //public static 

}